const styles = {
  container: {
    backgroundColor: 'kit.background.gray',
    padding: {
      xs: '24px 16px',
      xl: '40px 62px',
    },
    borderRadius: '16px',
  },
  description: {
    color: 'kit.text.main',
    fontSize: {
      xs: '14px',
      xl: '18px',
    },
    lineHeight: {
      xs: '21px',
      xl: '26px',
    },
    marginBottom: {
      xs: '16px',
      xl: '25px',
    },
  },
  list: {
    color: 'kit.text.main',
    marginBottom: '56px',
    display: {
      xs: 'none',
      xl: 'block',
    },
  },
  linkDesktop: {
    display: {
      xs: 'none',
      xl: 'inline',
    },
  },
  linkMbile: {
    marginTop: '32px',
    display: {
      xs: 'inline-block',
      xl: 'none',
    },
  },
  videoWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: {
      xl: '32px',
    },
  },
};

export default styles;
